import React from 'react';
import PropTypes from 'prop-types';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import utils from 'helpers/utils';

const ProductMembershipsList = (props) => {
    const {
        memberships,
        resource,
    } = props;

    if (utils.isEmpty(memberships)) {
        return <NoResults label='resources.access_points.no_results' />;
    }

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '90%' } } >
                    <FieldTitle
                        label='filters.components.name.label'
                        source='name'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
            </TableRow>

            {
                utils.map(memberships, (membership) => {
                    return (
                        <TableRow key={ `membership-${ membership.id }` } >
                            <TableBodyCell
                                field={ <TextField value={ membership.name } /> }
                                link={ 'show' }
                                record={ { id: membership.id } }
                                resource='product-memberships'
                                source='name'
                            />
                        </TableRow>
                    );

                })
            }
        </Table>
    );
};

ProductMembershipsList.propTypes = {
    memberships: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
};

export default ProductMembershipsList;


// WEBPACK FOOTER //
// ./src/pages/products/memberships/ProductMembershipsList.js